import { RowLabelsDto } from "@/dtos";
import { Labels } from "@/entities";

export const formatRowLabels = async (passengerGroups: Labels[]): Promise<RowLabelsDto[]> => {
    return passengerGroups.map((x) => {
        const row: RowLabelsDto = {
            ...x,
            id: x.id,
            name: x.name,
            is_active: x.is_active,
        }
        return row;
    });
}
